// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__37nY3","card":"Cards_card__3tXu5","infected":"Cards_infected__TCT5x","recovered":"Cards_recovered__TG7r5","deaths":"Cards_deaths__1hf9C"};